import EmblaCarousel from "embla-carousel";
window.EmblaCarousel = EmblaCarousel;

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus'
import Clipboard from '@ryangjchandler/alpine-clipboard';

import ajax from '@imacrayon/alpine-ajax';
import intersectClass from 'alpinejs-intersect-class';

window.Alpine = Alpine;
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(Clipboard);

Alpine.plugin(ajax);
Alpine.plugin(intersectClass);

Alpine.start();

// Maps
import Maps from './modules/_maps.js';

// Social share links
import Socials from './modules/_social_share_links.js';

function init() {
  Socials.setup();
  Maps.setup();
}

init();